export default __webpack_public_path__ + "static/media/howItWorksPlanet.2b7ac48f.svg";